import '../input/radio-input';
import '../cart/cart-summary';

import{ html, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { CheckoutForm } from './checkout-form';
import { CartData, cartStore } from '../../_stores/cart-store';
import { Prop } from '../cart/cart-summary';


@customElement('payment-form')
export class PaymentForm extends CheckoutForm {

    @property({ type: String, attribute: 'action-input' })
    actionInput: string = '';

    @property({ type: String, attribute: 'cancel-input' })
    cancelInput: string = '';

    @property({ type: String, attribute: 'redirect-input' })
    redirectInput: string = '';

    @property({ type: String, attribute: 'gateway-input' })
    gatewayInput: string = '';

    @state()
    _gatewayForm: string = '';

    // Lifecycle Hooks

    firstUpdated() {

        // add classes
        this.classList.add('Form', 'Form--payment');

		// handle slots
        const crsfSlot: HTMLElement | null = this.querySelector('[slot="crsf"]');
        if (crsfSlot) {
            this._crsf = crsfSlot.innerHTML;
            crsfSlot.remove();
        }

        // handle slots
        const formSlot: HTMLElement | null = this.querySelector('[slot="gateway-form"]');
        if (formSlot) {
            this._gatewayForm = formSlot.innerHTML;
            formSlot.remove();
        }
    }

    // Render

    render() {
        const cartData = cartStore.data.get();
        const readyForPayment = Boolean(cartData?.totalQty && cartData?.shippingAddress && cartData?.shippingMethodHandle && cartData?.gatewayId);
        const props: Prop[] = [
            { label: 'Subtotal', name: 'itemSubtotalAsCurrency' },
            { label: 'Tax', name: 'totalTaxAsCurrency' },
            { label: 'Shipping', name: 'totalShippingCostAsCurrency' },
            { label: 'Total', name: 'totalAsCurrency' },
        ];
        return html`
            <form method="post">
                ${ unsafeHTML(this._crsf) }
                <div hidden>${ unsafeHTML(this._gatewayForm) }</div>
                ${ this.hiddenInputTemplate('action', this.actionInput) }
                ${ this.hiddenInputTemplate('redirect', this.redirectInput) }
                ${ this.hiddenInputTemplate('cancelUrl', this.cancelInput) }
                ${ this.hiddenInputTemplate('gatewayId', this.gatewayInput) }
                <header class="Form-header">
                    <h4>Summary</h4>
                </header>
                <section class="Form-body">
                    <cart-summary
                        .props="${ props }"
                    ></cart-summary>
                </section>
				${ (cartData && cartData.shippingAddress) ? this.footerTemplate(readyForPayment) : '' }
            </form>
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Methods
    
    protected async _submit() {
        this._form.submit();
    }

	// Templates
	footerTemplate(readyForPayment: boolean): TemplateResult {
		return html`
			<footer class="Form-footer">
				${ this.submitButtonTemplate('submit', 'Pay with Stripe', !readyForPayment) }
			</footer>
		`;
	}

}